export const findFatalEntityEditValidationErrors = edits => {
    if (edits && edits.name && edits.name.includes('"')) return 'POI name cannot contain double quote character (")';

    return null;
};

export const sanitizeTagArrays = edits => {
    if (!edits) return edits;
    const sanitized = { ...edits };
    if (Array.isArray(sanitized.tags)) {
        sanitized.tags = sanitized.tags
            .filter(t => typeof t === 'string')
            .map(t => t.trim())
            .filter(Boolean);
    }
    if (Array.isArray(sanitized.displayTags)) {
        sanitized.displayTags = sanitized.displayTags
            .filter(t => typeof t === 'string')
            .map(t => t.trim())
            .filter(Boolean);
    }
    return sanitized;
};
